import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-carrello-pieno',
  templateUrl: './dialog-carrello-pieno.component.html',
  styleUrls: ['./dialog-carrello-pieno.component.css']
})
export class DialogCarrelloPienoComponent {

  titolo = '';
  messaggio = '';
  testoOk = '';
  testoCancel = '';
  visualizzaCancel = true;
  confermaAzione = true;

  constructor(
    public dialogRef: MatDialogRef<DialogCarrelloPienoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = data.titolo;
    this.messaggio = data.messaggio;
    this.testoOk = data.testoOk;
    this.testoCancel = data.testoCancel;
    this.visualizzaCancel = data.visualizzaCancel;
    this.confermaAzione = data.confermaAzione;
  }

  ngOnInit(): void {
  }

  ok() {
    this.dialogRef.close(true);
  }
  cancel() {
    this.dialogRef.close(false);
  }
}
